import styled from "@emotion/styled";

const cardStyles = (theme) => ({
  background: theme.palette.system[0],
  padding: theme.spacing(1.5, 1.75),
  borderRadius: theme.spacing(1),
  boxShadow: theme.shadows[4],
  boxSizing: "border-box"
});

const HyroChartTooltipCard = styled("div")(({ theme }) => cardStyles(theme));

export const chartTooltipCardSx = (theme) => ({
  ...cardStyles(theme),
  color: "inherit",
  maxWidth: "none"
});

export const compactChartTooltipSx = (theme) => ({
  backgroundColor: theme.palette.system[0],
  color: "inherit",
  borderRadius: "4px",
  boxShadow: theme.shadows[4]
});

export default HyroChartTooltipCard;
